import { MapToContext } from '@utils/objectWithDefault'

export class FulfillmentCenterModel {
  constructor (fulfillmentCenterData) {
    const defaultFulfillmentCenterData = {
      id: { val: 0, type: Number },
      name: { val: '', type: String },
      type: { val: 0, type: Number }
    }

    MapToContext(this, defaultFulfillmentCenterData, fulfillmentCenterData)
  }
}

export class FulfillmentCentersModel {
  constructor (fcListData) {
    const defaultFCList = { fcList: { val: [], type: Array, subType: FulfillmentCenterModel } }
    MapToContext(this, defaultFCList, fcListData)
  }
}

export class FulfillmentCenterDetailsModel extends FulfillmentCenterModel {
  constructor (fulfillmentCenterDetailsData) {
    super(fulfillmentCenterDetailsData)
    const defaultFulfillmentCenterDetailsData = {
      timezone: { val: '', type: String },
      streetAddress1: { val: '', type: String },
      streetAddress2: { val: '', type: String },
      city: { val: '', type: String },
      state: { val: '', type: String },
      country: { val: '', type: String },
      zipCode: { val: '', type: String },
      phone: { val: '', type: String },
      email: { val: '', type: String },
      information: { val: new FulfillmentCenterInformation(), type: FulfillmentCenterInformation }
    }

    MapToContext(this, defaultFulfillmentCenterDetailsData, fulfillmentCenterDetailsData)
  }
}

export class FulfillmentCenterInformation {
  constructor (infoData) {
    const defaultInfoData = {
      sendInventoryPageNotice: { val: '', type: String }
    }

    MapToContext(this, defaultInfoData, infoData)
  }
}

export class FulfillmentCenterDetailsListModel {
  constructor (fcListData) {
    const defaultFCList = { fcList: { val: [], type: Array, subType: FulfillmentCenterDetailsModel } }
    MapToContext(this, defaultFCList, fcListData)
  }
}

export class AddressModel {
  constructor (addressData) {
    const defaultAddressData = {
      name: { val: '', type: String },
      address1: { val: '', type: String },
      address2: { val: '', type: String },
      city: { val: '', type: String },
      state: { val: '', type: String },
      country: { val: '', type: String },
      zipCode: { val: '', type: String },
      phoneNumber: { val: '', type: String },
      email: { val: 'support@shipbob.com', type: String }
    }
    MapToContext(this, defaultAddressData, addressData)
  }
}

export class ServiceModel {
  constructor (serviceData) {
    const defaultServiceData = {
      serviceType: { val: '', type: String },
      enabled: { val: false, type: Boolean },
      address: { val: new AddressModel(), type: AddressModel }
    }
    MapToContext(this, defaultServiceData, serviceData)
  }
}

export class LocationModel {
  constructor (locationData) {
    const defaultLocationData = {
      id: { val: 0, type: Number },
      name: { val: '', type: String },
      isActive: { val: false, type: Boolean },
      accessGranted: { val: false, type: Boolean },
      attributes: { val: [], type: Array, subType: String },
      services: { val: [], type: Array, subType: ServiceModel }
    }
    MapToContext(this, defaultLocationData, locationData)
  }

  getService (serviceType) {
    return this.services.find(s => s.serviceType === serviceType)
  }
}

export class LocationsModel {
  constructor (locationsData) {
    const defaultLocations = { locations: { val: [], type: Array, subType: LocationModel } }
    MapToContext(this, defaultLocations, locationsData)
  }

  where (fn) {
    return this.locations.filter(fn)
  }
}

export class FulFillmentCenterRulesModel {
  constructor (rulesData) {
    const defaultRules = { regionId: { val: null, type: String }, searchString: { val: '', type: String } }
    MapToContext(this, defaultRules, rulesData)
  }
}

export class DestinationCountry {
  constructor (destinationCountryData) {
    const defaultDestinationCountry = {
      name: { val: '', type: String },
      id: { val: 0, type: Number },
      isoCode: { val: '', type: String }
    }

    MapToContext(this, defaultDestinationCountry, destinationCountryData)
  }
}

export class DestinationCountries {
  constructor (destinationCountriesData) {
    const defaultDestinationCountries = {
      countries: { val: [], type: Array, subType: DestinationCountry }
    }

    if (destinationCountriesData != null && destinationCountriesData.countries != null) {
      destinationCountriesData.countries = destinationCountriesData.countries.sort((a, b) => a.name > b.name ? 1 : -1)
    }

    MapToContext(this, defaultDestinationCountries, destinationCountriesData)
  }

  getCountries () {
    return this.countries
  }
}

export class GlobalRegion {
  constructor (globalRegionData) {
    const defaultGlobalRegion = {
      name: { val: '', type: String },
      id: { val: 0, type: Number }
    }

    MapToContext(this, defaultGlobalRegion, globalRegionData)
  }
}

export class GlobalRegions {
  constructor (globalRegionsData) {
    const defaultGlobalRegions = {
      regions: { val: [], type: Array, subType: GlobalRegion }
    }

    MapToContext(this, defaultGlobalRegions, globalRegionsData)
  }
}

export class AddRuleModel {
  constructor (addRuleData) {
    const defaultAddRuleModel = {
      country_ids: { val: [], type: Array, subType: Number },
      fulfillment_center_id: { val: 0, type: Number },
      enabled: { val: true, type: Boolean }
    }

    MapToContext(this, defaultAddRuleModel, addRuleData)
  }
}

export class CountriesByRegionModel {
  constructor (regionData) {
    const defaultRegionData = { region_id: { val: null, type: Number } }
    MapToContext(this, defaultRegionData, regionData)
  }
}

export class LocationsShippableToCountriesModel {
  constructor (countriesData) {
    const defaultCountriesData = { country_ids: { val: null, type: Array, subType: Number } }
    MapToContext(this, defaultCountriesData, countriesData)
  }
}

export class EnableDisableDeleteFcRuleModel {
  constructor (ruleData) {
    const defaultAddRuleModel = {
      UserFulfillmentCenterConfigIds: { val: [], type: Array, subType: Number }
    }

    MapToContext(this, defaultAddRuleModel, ruleData)
  }
}
